import React from 'react';
import './RatingStrawberries.css';

export const RatingStrawberries = React.memo(function RatingStrawberries({ 
  rating, 
  ratingCount, 
  onClick,
  showRatingsOverview,
  showDecimals = true,
  showRatingCount = true,
  readonly = false,
  disableHover = false,
  small = false
}) {
  const formattedRating = showDecimals 
    ? parseFloat(rating).toFixed(1)
    : Math.round(rating).toString();

  return (
    <div 
      className="rating-display" 
      onClick={showRatingsOverview || onClick}
      style={{ cursor: (showRatingsOverview || onClick) ? 'pointer' : 'default' }}
    >
      <div className="rating-group">
        <div className="icon-column">
          <img 
            src="/images/strawberry-filled.png" 
            alt="Rating"
            className="strawberry-icon"
          />
        </div>
        <div className="info-column">
          <span className="rating-value">
            {formattedRating}<span className="rating-scale"> / 5</span>
            {showRatingCount && (
              <span className="votes-count">
                {ratingCount > 0 ? ` (${ratingCount})` : " (0)"}
              </span>
            )}
          </span>
        </div>
      </div>
    </div>
  );
});

// Add display name for debugging
RatingStrawberries.displayName = 'RatingStrawberries'; 